<div class="p-dialog-content__dynamic">
  <p-calendar
    #calendar
    appendTo="body"
    class="w-100"
    placeholder="Select Date Range"
    [(ngModel)]="rangeDates"
    selectionMode="range"
    [inputStyle]="{'width':'100%'}"
    (onSelect)="onDateRangeSelect()"
    [readonlyInput]="true">
  </p-calendar>
  <p *ngIf="isError" class="internal-server-error">Please, select date range</p>
</div>


<div class="p-dialog-footer p-dialog-footer__dynamic">
  <button class="cancel-btn medium" (click)="cancelClicked()">Cancel</button>
  <button class="regular-btn medium" (click)="saveClicked()">
    Save
  </button>
</div>
